import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";

function getBannerTitle(path) {
  switch (path) {
    case "/":
      return "Trang chủ";
    case "/thong-tin-hanh-khach":
      return "Thông tin khách hàng";
    case "/thong-tin-dich-vu":
      return "Dịch vụ bổ sung";
    case "/thong-tin-thanh-toan":
      return "Thanh toán";
    case "/thong-tin-ve":
      return "Kết quả đặt vé";
    default:
      return "";
  }
}

function getBannerBreadcrumb(path) {
  switch (path) {
    case "/":
      return null;
    case "/thong-tin-hanh-khach":
      return (
        <li>
          <span><i className="fas fa-circle"></i></span> Thông tin khách hàng
        </li>
      );
    case "/thong-tin-dich-vu":
      return (
        <li>
          <span><i className="fas fa-circle"></i></span> Dịch vụ bổ sung
        </li>
      );
    case "/thong-tin-thanh-toan":
      return (
        <li>
          <span><i className="fas fa-circle"></i></span> Thanh toán
        </li>
      );
    case "/thong-tin-ve":
      return (
        <li>
          <span><i className="fas fa-circle"></i></span> Kết quả đặt vé
        </li>
      );
  }
}

export default function Header() {
  // State for mobile menu open/close
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  // State for current active path
  const location = useLocation();
  const [activePath, setActivePath] = useState(location.pathname);

  // Update activePath when route changes
  React.useEffect(() => {
    setActivePath(location.pathname);
  }, [location.pathname]);

  // Helper to check if a path is active (strict match)
  const isActive = (paths) => {
    return paths.includes(activePath);
  };

  return (
    <>
      <header className="main_header_arae">
        <div className="topbar-area">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-lg-6 col-md-6">
                <ul className="topbar-list">
                  <li>
                    {/* Social icons: giữ nguyên nếu chỉ là placeholder */}
                    <a href="https://www.facebook.com/vemaybaygiarethanhhoang/" target="_blank">
                      <i className="fab fa-facebook"></i>
                    </a>
                    <a href="#">
                      <i className="fab fa-twitter-square"></i>
                    </a>
                    <a href="#">
                      <i className="fab fa-instagram"></i>
                    </a>
                    <a href="#">
                      <i className="fab fa-linkedin"></i>
                    </a>
                  </li>
                  <li>
                    <a href="tel:0979969010">
                      <span>0979 969 010</span>
                    </a>
                  </li>
                  <li>
                    <a href="mailto:vemaybay@thanhhoang.vn">
                      <span>vemaybay@thanhhoang.vn</span>
                    </a>
                  </li>
                </ul>
              </div>
              {/* <div className="col-lg-6 col-md-6">
                <ul className="topbar-others-options">
                  <li>
                    <Link to="/login" className="">
                      Login
                    </Link>
                  </li>
                  <li>
                    <Link to="/register" className="">
                      Sign up
                    </Link>
                  </li>
                  <li>
                    <div className="dropdown language-option">
                      <select>
                        <option value="English">English</option>
                        <option value="Arabic">Arabic</option>
                        <option value="French">French</option>
                      </select>
                    </div>
                  </li>
                  <li>
                    <div className="dropdown language-option">
                      <select>
                        <option value="USD">USD</option>
                        <option value="BD">BD</option>
                        <option value="URO">URO</option>
                      </select>
                    </div>
                  </li>
                </ul>
              </div> */}
            </div>
          </div>
        </div>
        {/* <div className="navbar-area">
          <div className="main-responsive-nav">
            <div className="container">
              <div className="main-responsive-menu mean-container">
                <nav className="navbar">
                  <div className="container">
                    <div className="logo">
                      <Link to="/" className="">
                        <img
                          src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAALoAAAA/CAYAAABXc9KaAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAABMMSURBVHgB..."
                          alt="logo"
                        />
                      </Link>
                    </div>
                    <button
                      className={`navbar-toggler${mobileMenuOpen ? "" : " collapsed"
                        }`}
                      type="button"
                      // Toggle mobile menu
                      onClick={() => setMobileMenuOpen((open) => !open)}
                      aria-expanded={mobileMenuOpen}
                    >
                      <div className="hamburger-toggle">
                        <div className="hamburger">
                          <span></span>
                          <span></span>
                          <span></span>
                        </div>
                      </div>
                    </button>
                    <div
                      className={`collapse navbar-collapse mean-nav${mobileMenuOpen ? " show" : ""
                        }`}
                      id="navbar-content"
                    >
                      <ul className="navbar-nav mr-auto mb-2 mb-lg-0">
                        <li className="nav-item dropdown">
                          <Link
                            to="/"
                            className={`dropdown-item dropdown-toggle`}
                            data-bs-toggle="dropdown"
                            data-bs-auto-close="outside"
                            onClick={() => setActivePath("/")}
                          >
                            Home 1
                          </Link>
                          <ul className={`dropdown-menu shadow ${isActive(["/", "/home-two"]) ? " show" : ""}`}>
                            <li className="nav-item">
                              <Link
                                to="/"
                                className={`dropdown-item`}
                                onClick={() => setActivePath("/")}
                              >
                                Home One
                              </Link>
                            </li>
                            <li className="nav-item">
                              <Link
                                to="/home-two"
                                className={`dropdown-item$`}
                                onClick={() => setActivePath("/home-two")}
                              >
                                Home Two
                              </Link>
                            </li>
                          </ul>
                        </li>
                        <li className="nav-item dropdown">
                          <Link
                            to="/tour-search"
                            className={`dropdown-item dropdown-toggle`}
                            data-bs-toggle="dropdown"
                            data-bs-auto-close="outside"
                            onClick={() => setActivePath("/tour-search")}
                          >
                            Tours
                          </Link>
                           <ul className={`dropdown-menu shadow ${isActive(["/tour-search",
                              "/tour-details",
                              "/tour-booking-submission",
                              "/top-destinations",
                            ]) ? " show" : ""}`}>
                            <li className="nav-item">
                              <Link
                                to="/tour-search"
                                className={`nav-link$`}
                                onClick={() => setActivePath("/tour-search")}
                              >
                                Tour
                              </Link>
                            </li>
                            <li className="nav-item">
                              <Link
                                to="/tour-details"
                                className={`nav-link`}
                                onClick={() => setActivePath("/tour-details")}
                              >
                                Tour Details
                              </Link>
                            </li>
                            <li className="nav-item">
                              <Link
                                to="/tour-booking-submission"
                                className={`nav-link`}
                                onClick={() => setActivePath("/tour-booking-submission")}
                              >
                                Tour Booking
                              </Link>
                            </li>
                            <li className="nav-item">
                              <Link
                                to="/top-destinations"
                                className={`nav-link`}
                                onClick={() => setActivePath("/top-destinations")}
                              >
                                Top Destination
                              </Link>
                            </li>
                          </ul>
                        </li>
                        <li className="nav-item">
                          <Link
                            to="/contact"
                            className={`dropdown-item`}
                          >
                            Contact
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </div>
                </nav>
              </div>
            </div>
          </div>
          <div className="main-navbar">
            <div className="container">
              <nav className="navbar navbar-expand-md navbar-light">
                <Link to="/" className="navbar-brand">
                  <img
                    src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAALoAAAA/CAYAAABXc9KaAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAABMMSURBVHgB7Z0JuB1FsccrgSyEBEEgIGAIAQI8NuVJ4IVdzJNFCIHwEAVJQOQhvIco4gI+4SkaVxRE2URAIS4kYEBAtkRFFolsgiwCCauoEJElBIIp65fu4fbt23POzL1zbu65mf/31XfO6anu6TNT01NdVV09QNoMqrqlfUw22sHoaaNzjW4ZMGCASo0aORggbQQT8u3s4+dGawXFrxmdZI..."
                    alt="Base64 Image"
                  />
                </Link>
                <div
                  className="collapse navbar-collapse mean-menu"
                  id="navbarSupportedContent"
                >
                  <ul className="navbar-nav">
                    <li className="nav-item">
                      <Link
                        to="/"
                        className={`nav-link${isActive(["/", "/home-two"]) ? " active" : ""}`}
                        onClick={() => setActivePath("/")}
                      >
                        Home <i className="fas fa-angle-down"></i>
                      </Link>
                      <ul className="dropdown-menu">
                        <li className="nav-item">
                          <Link
                            to="/"
                            className={`nav-link${isActive(["/"]) ? " active" : ""}`}
                            onClick={() => setActivePath("/")}
                          >
                            Home One
                          </Link>
                        </li>
                        <li className="nav-item">
                          <Link
                            to="/home-two"
                            className={`nav-link${isActive(["/home-two"]) ? " active" : ""}`}
                            onClick={() => setActivePath("/home-two")}
                          >
                            Home Two
                          </Link>
                        </li>
                      </ul>
                    </li>
                    <li className="nav-item">
                      <Link
                        to="/tour-search"
                        className={`nav-link${isActive([
                          "/tour-search",
                          "/tour-details",
                          "/tour-booking-submission",
                          "/top-destinations",
                        ]) ? " active" : ""}`}
                        onClick={() => setActivePath("/tour-search")}
                      >
                        Tours<i className="fas fa-angle-down"></i>
                      </Link>
                      <ul className="dropdown-menu">
                        <li className="nav-item">
                          <Link
                            to="/tour-search"
                            className={`nav-link${isActive(["/tour-search"]) ? " active" : ""}`}
                            onClick={() => setActivePath("/tour-search")}
                          >
                            Tour
                          </Link>
                        </li>
                        <li className="nav-item">
                          <Link
                            to="/tour-details"
                            className={`nav-link${isActive(["/tour-details"]) ? " active" : ""}`}
                            onClick={() => setActivePath("/tour-details")}
                          >
                            Tour Details
                          </Link>
                        </li>
                        <li className="nav-item">
                          <Link
                            to="/tour-booking-submission"
                            className={`nav-link${isActive(["/tour-booking-submission"]) ? " active" : ""}`}
                            onClick={() => setActivePath("/tour-booking-submission")}
                          >
                            Tour Booking
                          </Link>
                        </li>
                        <li className="nav-item">
                          <Link
                            to="/top-destinations"
                            className={`nav-link${isActive(["/top-destinations"]) ? " active" : ""}`}
                            onClick={() => setActivePath("/top-destinations")}
                          >
                            Top Destination
                          </Link>
                        </li>
                      </ul>
                    </li>
                    <li className="nav-item">
                      <Link
                        to="/contact"
                        className={`nav-link${isActive(["/contact"]) ? " active" : ""}`}
                        onClick={() => setActivePath("/contact")}
                      >
                        Contact
                      </Link>
                    </li>
                  </ul>
                  <div className="others-options d-flex align-items-center">
                    <div className="option-item">
                      <Link to="/become-vendor" className="btn btn_navber">
                        Become a partner
                      </Link>
                    </div>
                  </div>
                </div>
              </nav>
            </div>
          </div>
          <div className="others-option-for-responsive">
            <div className="container">
              <div className="container">
                <div className="option-inner">
                  <div className="others-options d-flex align-items-center">
                    <div className="option-item">
                      <a href="#" className="search-box">
                        <i className="fas fa-search"></i>
                      </a>
                    </div>
                    <div className="option-item">
                      <Link to="/contact" className="btn btn_navber">
                        Get free quote
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div> */}
      </header>
      {/* Banner động theo router */}
      <section id="common_banner">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="common_bannner_text">
                {/* <h2>{getBannerTitle(activePath)}</h2> */}
                <h2></h2>
                <ul>
                  <li>
                    {/* <Link to="/" className="">
                      Trang chủ
                    </Link> */}
                  </li>
                  {/* {getBannerBreadcrumb(activePath)} */}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}